<button
  mat-icon-button
  type="button"
  [matMenuTriggerFor]="menu"
  [attr.aria-label]="'balance.benefits.options.aria-label' | translate"
  data-balance-benefits-options-trigger>
  <mat-icon>more_vert</mat-icon>
</button>

<mat-menu #menu="matMenu" class="balance-benefits-options-menu" data-balance-benefits-options-menu>
  <div class="balance-benefits-options-menu__content" (click)="$event.stopPropagation()">
    <p
      *ngIf="!hasSecondaryInsurance; else toggles"
      class="balance-benefits-options-menu__empty"
      data-balance-benefits-options-empty>
      {{ 'balance.benefits.options.no-secondary-on-file' | translate }}
    </p>

    <ng-template #toggles>
      <mat-slide-toggle
        [checked]="hasSecondary"
        (change)="onHasSecondaryToggle($event.checked)"
        data-balance-benefits-options-has-secondary>
        {{ 'balance.benefits.options.has-secondary' | translate }}
      </mat-slide-toggle>

      <ng-container *ngIf="hasSecondary" [formGroup]="form">
        <mat-slide-toggle
          formControlName="secondaryInsuranceCoversDeductible"
          (change)="onCoversChange()"
          data-balance-benefits-options-covers-deductible>
          {{ 'balance.benefits.options.covers-deductible' | translate }}
        </mat-slide-toggle>
        <mat-slide-toggle
          formControlName="secondaryInsuranceCoversCopayment"
          (change)="onCoversChange()"
          data-balance-benefits-options-covers-copayment>
          {{ 'balance.benefits.options.covers-copayment' | translate }}
        </mat-slide-toggle>
        <mat-slide-toggle
          formControlName="secondaryInsuranceCoversCoinsurance"
          (change)="onCoversChange()"
          data-balance-benefits-options-covers-coinsurance>
          {{ 'balance.benefits.options.covers-coinsurance' | translate }}
        </mat-slide-toggle>
      </ng-container>
    </ng-template>
  </div>
</mat-menu>
